import React, { useEffect, useState } from "react";
import { api, STORE_SLUG } from "../lib/api";
import { Megaphone, Clock } from "lucide-react";

export const PromoBar = () => {
  const [store, setStore] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    api.get(`/stores/${STORE_SLUG}`).then((r) => setStore(r.data)).catch(() => {});
    const t = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(t);
  }, []);

  if (!store || !store.banner_enabled) return null;
  const hype = (store.hype_banner || "").trim();
  const deadlineMs = store.order_deadline ? new Date(store.order_deadline).getTime() : 0;

  let countdown = null;
  if (deadlineMs) {
    const diff = deadlineMs - now;
    if (diff > 0) {
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      countdown = `${d}d ${h}h ${m}m left to order`;
    } else {
      countdown = "Ordering closed";
    }
  }
  if (!hype && !countdown) return null;

  return (
    <div className="bg-[var(--gv-blue)] text-black" data-testid="promo-bar">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-center">
        {hype && (
          <span className="flex items-center gap-2 font-bold text-sm uppercase tracking-wide" data-testid="promo-hype">
            <Megaphone className="w-4 h-4 flex-shrink-0" /> {hype}
          </span>
        )}
        {countdown && (
          <span className="flex items-center gap-2 font-bold text-sm" data-testid="promo-countdown">
            <Clock className="w-4 h-4 flex-shrink-0" /> {countdown}
          </span>
        )}
      </div>
    </div>
  );
};
